import React from "react";
import styles from "./ArtYerkirSection.module.scss";
import Title from "components/title/Title";
import ArtYerkirCard from "components/cards/artYerkirCard/ArtYerkirCard";
import cardImage from "../../../assets/images/card-image.jpg";

const artYerkirCards = [
  {
    id: 1,
    type: "Interview",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 2,
    type: "Interview",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 3,
    type: "Interview",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 4,
    type: "Article",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 5,
    type: "Article",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 6,
    type: "Article",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 7,
    type: "Report",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 8,
    type: "Report",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
  {
    id: 9,
    type: "Report",
    title: "Title Of The Work",
    date: "18 Aug, 2024",
    description: "Here can be the start of the text till the",
    image: cardImage,
  },
];

const ArtYerkirSection = () => {
  return (
    <div className={styles.artYerkirSectionContainer}>
      <div className="container">
        <Title text={"Art Yerkir"} bottomStrokeWidth={"61%"} />
        <p className={styles.description}>
          Discover the latest interviews, articles, and reports in the world of
          art
        </p>
        <div className={styles.artYerkirList}>
          {artYerkirCards.map((item) => {
            return <ArtYerkirCard key={item.id} item={item} />;
          })}
        </div>
        <div className={styles.viewAllCentered}>View All</div>
      </div>
    </div>
  );
};

export default ArtYerkirSection;
